module.exports = __webpack_public_path__ + "static/logo_footer-97d41d4f3a4035876d120760ae5de9c0.svg";